<template>
    <div class="root_header">
        <header id="header" class="header" @click="reloadPage()">
            <div class="header_page">
                <div class="logout_back">
                    <img src="../assets/images/logout.png" @click.stop="showmodalConfig = true" alt="btn logout" class="btn_logout" title="Đăng xuất" v-if="this.$route.name == 'Home_tool'">
                    <img src="../assets/images/back.png" @click.stop="goBack" alt="btn back" class="btn_logout" title="Quay lại" v-else-if="this.$route.name != 'QrAccount_tool'">
                    <img src="../assets/images/load.png" @click.stop="goLoadPage()" alt="btn back" class="btn_logout" title="Tải lại" v-else>
                    <router-link to="/qr-account" @click.stop v-if="this.$route.name != 'QrAccount_tool'">
                        <img src="../assets/images/qr3.png" alt="btn download" class="btn_download animation_qr" title="qr">
                    </router-link>
                    <!--  @click.stop="clickShowPpQr()"
                    v-if="imgQr != null"
                    <img src="../assets/images/qr3.png" @click.stop="" alt="btn download" class="btn_download" title="qr" v-else> -->
                </div>
                <router-link to="/loading" @click.stop>
                    <img src="../assets/images/logo.png" alt="" class="logo_header">
                </router-link>
                <div class="qrcode_notify">
                    <ul>
                        <li v-if="this.$route.name != 'QrAccount_tool'">
                            <router-link to="/qr" @click.stop>
                                <img src="../assets/images/ac.png" alt="" class="qrCode_header">
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/notification" v-if="this.$route.name == 'Home_tool'" @click.stop>
                                <img src="../assets/images/bell.png" alt="" class="bell_header">
                            </router-link>
                            <router-link to="/" v-else @click.stop>
                                <img src="../assets/images/home.png" alt="btn home" class="btn_home" title="Trang chủ">
                            </router-link>
                        </li>
                    </ul>
                </div>
                <div class="modalRedirect" @click.stop="" v-if="showmodal">
                    <div class="content_modalredirect content_modalredirectHd" @click.stop="">
                        <p @click.stop="showmodal = false" class="closeMdredirect"><img src="../assets/images/close.png" @click.stop="clickhidePpQr()" alt=""></p>
                        <h3 @click.stop="">Mã QR doanh nghiệp</h3>
                        <p class="nameCompanyPp" v-if="nameCompany != null">{{ nameCompany }}</p>
                        <div class="imgQrDownload" @click.stop="">
                            <img :src="linkWebAdmin + imgQr" alt="" @click.stop="">
                        </div>
                        <div class="textTime">
                            Mã định danh chỉ có hiệu lực 1 phút
                            <p v-if="check == 0">{{ formattedMinutes }}:{{ formattedSeconds }}</p>
                            <p v-else>Mã hết hiệu lực</p>
                        </div>
                        <div class="btnSaveQr" @click.stop="">
                            <button @click.stop="hideShowModal()">Lưu về máy</button>
                        </div>
                    </div>
                </div>
                <div class="modalRedirect" @click.stop="" v-if="showmodals">
                    <div class="content_modalredirect content_modalredirectHds" @click.stop="">
                        <p @click.stop="showmodals = false" class="closeMdredirect"><img src="../assets/images/close.png" @click.stop="clickhidePpQrs()" alt=""></p>
                        <h3 @click.stop="">Mã QR doanh nghiệp</h3>
                        <div class="imgQrDownload" @click.stop="">
                            <img :src="linkWebAdmin + imgQr" alt="" @click.stop="">
                        </div>
                    </div>
                </div>
                <!-- <div class="modalRedirect" @click.stop="" v-if="showmodalConfig">
                    <div class="content_modalredirect content_modalredirectHds" @click.stop="">
                        <p @click.stop="showmodalConfig = false" class="closeMdredirect"><img src="../assets/images/close.png" @click.stop="showmodalConfig = false" alt=""></p>
                        <h3 @click.stop="">Bạn có chắc muốn đăng xuất</h3>
                        <div class="btnLogout_modal" @click.stop="">
                            <ul @click.stop="">
                                <li @click.stop="logout">Xác nhận</li>
                            </ul>
                        </div>
                    </div>
                </div> -->
                <div class="modalRedirect modal_register_success" v-if="showmodalConfig" @click.stop="">
                    <div class="content_modalredirect content_modalredirectHds" @click.stop="">
                        <p @click.stop="showmodalConfig = false" class="closeMdredirect"><img src="../assets/images/close.png" @click.stop="showmodalConfig = false" alt=""></p>
                        <div class="wrp_modal_type" @click.stop="">
                            <h6 @click.stop="">Bạn có chắc muốn đăng xuất</h6>
                            <div class="btnxn_modal" @click.stop="">
                                <a @click.stop="logout()">Xác nhận</a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </header>
    </div>
</template>

<script>
import $ from 'jquery'
import SocketIO from 'socket.io-client'
export default {
    name: 'Header_tool',
    data() {
        return {
            token: window.localStorage.getItem('token'),
            imgQr: '',
            nameCompany: '',
            showmodal: false,
            showmodals: false,
            timeLeft: 60,
            intervalId: null,
            check: 0,
            showmodalConfig: false,
            socket: null,
            other: []
        }
    },
    components: {

    },
    computed: {
        formattedMinutes() {
            return String(Math.floor(this.timeLeft / 60)).padStart(2, '0');
        },
        formattedSeconds() {
            return String(this.timeLeft % 60).padStart(2, '0');
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll)
        this.getDataListInfo()
        this.socketEventQr()
        this.socketEventCheck()
        this.socketEventLogout()
    },
    beforeUnmount() {
        
    },
    methods: {
        handleScroll() {
            if (window.scrollY > 100) {
                this.classHeader = 'active'
            } else {
                this.classHeader = ''
            }
        },
        logout() {
            $('#loadingImg').show().fadeIn(10)
            this.axios.post(this.api_Logout,
                {

                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                $('#loadingImg').css('display', 'none')
                // localStorage.clear();
                localStorage.removeItem('token');
                localStorage.removeItem('idUser');
                this.$swal({
                    position: 'top-end',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                })
                setTimeout(() => {
                    window.location.href = '/'
                }, 2000);
            }).catch(e => {
                $('#loadingImg').css('display', 'none')
                if (e.response.status == 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'success',
                        title: 'Đăng xuất thành công',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        goBack() {
            this.$router.back();
        },
        reloadPage() {
            window.location.reload();
        },
        getDataListInfo () {
            this.axios.get(this.api_userInfo,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.nameCompany = response.data.data.company_name
                this.imgQr = response.data.data.qr_user
            }).catch(e => {
                if(e.response.status == 401){
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        // async downloadImage() {
        //     try {
        //         const imageUrl = this.linkWebAdmin + this.imgQr;
        //         const response = await fetch(imageUrl, {
        //             mode: 'cors',
        //         });

        //         if (!response.ok) {
        //             throw new Error('Không thể fetch ảnh');
        //         }
        //         const blob = await response.blob();
        //         const url = URL.createObjectURL(blob);

        //         const a = document.createElement('a');
        //         a.href = url;
        //         a.download = 'qr-code.png';
        //         document.body.appendChild(a);
        //         a.click();
        //         document.body.removeChild(a);

        //         URL.revokeObjectURL(url);
        //     } catch (error) {
        //         console.error('Lỗi khi tải ảnh:', error);
        //     }
        // },
        hideShowModal () {
            this.showmodal = false
            this.showmodals = true
        },
        startCountdown() {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
            this.intervalId = setInterval(() => {
                if (this.timeLeft > 0) {
                    this.timeLeft--;
                } else {
                    clearInterval(this.intervalId);
                    if (this.showmodal) {
                        this.check = 1;
                    }
                }
            }, 1000);
        },
        clickShowPpQr () {
            this.timeLeft = 60
            this.startCountdown()
            this.showmodal = true
        },
        clickhidePpQr () {
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }
            this.showmodal = false
            this.check = 0
        },
        clickhidePpQrs () {
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }
            this.showmodals = false
            this.check = 0
        },
        socketEventQr () {
            var idUser = window.localStorage.getItem('idUser')
            this.socket = SocketIO(this.linkWebAdmin, { transports: ['websocket', 'polling', 'flashsocket'], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 2000 });
            this.socket.on(`laravel_database_load-business.${idUser}:ReloadEvent`, function(result) {
                // console.log('2222', result);
                if(result.data.load_qr == true){
                    window.location.reload()
                }
            });
        },
        goLoadPage () {
            window.location.reload()
        },
        socketEventCheck () {
            let thiss = this
            let ip = window.localStorage.getItem('ip')
            this.socket = SocketIO(this.linkWebAdmin, { transports: ['websocket', 'polling', 'flashsocket'], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 2000 });
            this.socket.on(`laravel_database_private-user_log_ip.${ip}:user-log`, function(result) {
                if(result.status == 0){
                    thiss.axios.post(thiss.api_Logout,
                        {

                        },
                        {
                            headers: {
                                Authorization: 'Bearer ' + thiss.token
                            }
                        }
                    ).then((response) => {
                        this.other = response
                        localStorage.removeItem('token');
                        localStorage.removeItem('idUser');
                        thiss.$swal({
                            position: 'top-end',
                            icon: 'success',
                            title: 'Kết thúc phiên đăng nhập',
                            showConfirmButton: false,
                            timer: 2000
                        })
                        setTimeout(() => {
                            window.location.href = '/'
                        }, 2000);
                    }).catch(e => {
                        if (e.response.status == 401) {
                            localStorage.removeItem('token');
                            localStorage.removeItem('idUser');
                            thiss.$swal({
                                position: 'top-end',
                                icon: 'success',
                                title: 'Kết thúc phiên đăng nhập',
                                showConfirmButton: false,
                                timer: 2000
                            })
                            setTimeout(() => {
                                window.location.href = '/'
                            }, 2000);
                        }
                    })
                }
            });
        },
        socketEventLogout () {
            var idUser = window.localStorage.getItem('idUser')
            let thiss = this
            this.socket = SocketIO(this.linkWebAdmin, { transports: ['websocket', 'polling', 'flashsocket'], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 2000 });
            this.socket.on(`laravel_database_forceLogout.${idUser}:forceLogout`, function(result) {
                thiss.other = result
                localStorage.removeItem('token');
                localStorage.removeItem('idUser');
                setTimeout(() => {
                    window.location.href = '/'
                }, 200);
            });
        },
    }
}
</script>
<style>

</style>